import { EntityFileList } from '@/common/entities/entityFile/EntityFileList'
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList'
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'
import { useRsrc } from '@/common/rsrc/RsrcContext'
import { ValList } from '@/common/val/ValList'
import { IncDataSrcList } from '@/gp/entities/incDataSrc/IncDataSrcList'
import { IncListList } from '@/gp/entities/incList/IncListList'
import { PolFormulaList } from '@/gp/entities/polFormula/PolFormulaList'
import { useEffect, useState } from 'react'
import { PolForm } from './PolForm'

export const PolDetail = () => {

  const rsrc = useRsrc();
  const { entityObj } = useEntityMgr();

  const [groupToPolTypes, setGroupToPolTypes] = useState();

  useEffect(() => {
    rsrc.data('gp', 'POL_TYPE_DATA_PLUGIN', {}).then((groupToPolTypes) => {
      setGroupToPolTypes(groupToPolTypes);
    })
  }, [])

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <PolForm /> }];
  if (groupToPolTypes && entityObj.type) {
    if (!groupToPolTypes.derivedPolTypes.includes(entityObj.type)) {
      tabSpecs.push(
        { id: 'incDataSrcTab', label: 'Inclusion Data Sources', content: <IncDataSrcList polId={entityObj.id} /> },
        { id: 'incListTab', label: 'Inclusion Lists', content: <IncListList polId={entityObj.id} /> }
      )
    }

    if (groupToPolTypes.formulaBasedPolTypes.includes(entityObj.type)) {
      tabSpecs.push(
        { id: 'polFormulasTab', label: 'Formulas', content: <PolFormulaList polId={entityObj.id} /> }
      )
    }

    tabSpecs.push(
      { id: 'propTab', label: 'Properties', content: <EntityPropList parentEntity="POL" parentEntityObj={entityObj} /> },
      { id: 'valTab', label: 'Validations', content: <ValList parentEntity="POL" parentEntityId={entityObj.id} /> },
      { id: 'soxControlsTab', label: 'SOX Controls', content: <EntityFileList parentEntity="POL" parentEntityId={entityObj.id} /> },
    )
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}